import ProfileDto from '../../dto/profiles/out/profile.dto';

class GetProfileCompanyNameService {
  get({ commonCompanyName, legalCompanyName }: ProfileDto): string {
    return commonCompanyName ? commonCompanyName : legalCompanyName;
  }
}

export default GetProfileCompanyNameService;
